import React from 'react';
import './index.less';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import wrapReact from '../../../util/react';

const logoIcon = require('../../../static/image/SELogo.png');

export const Footer = (props) => {
  const { filePath, className } = props;
  return (
    <div className={`${filePath} ${className}`}>
      <div className="footCon">
        <div className="msgCon">
          <FormattedMessage
            id="Footer.copyright"
            defaultMessage="This application is protected by copyright law and international treaties. ©2021 Schneider Electric Industries SAS. All rights reserved."
            className="copyright"
          />
          <FormattedMessage
            id="Footer.contact"
            defaultMessage="contact us: {email} {name} Ver: {ver}"
            className="contact"
            values={{
              email: (
                <a href="mailto:tsc-wiehl@se.com">
                  <FormattedMessage
                    id="Footer.email"
                    defaultMessage="tsc-wiehl@se.com"
                    className="impressum"
                  />
                </a>
              ),
              name: (
                <a href="http://www.schneider-electric.de/de/about-us/legal/">
                  <FormattedMessage
                    id="Footer.impressum"
                    defaultMessage="impressum"
                    className="impressum"
                  />
                </a>
              ),
              ver: process.env.REACT_APP_VERSION,
            }}
          />
        </div>
        <img className="logoIcon" src={logoIcon} title="v2.0.9.1" alt="" />
      </div>
    </div>
  );
};

Footer.propTypes = {
  filePath: PropTypes.string.isRequired,
  className: PropTypes.string.isRequired,
};

export default wrapReact(Footer, 'page_index_footer');
